/**
 * An HTML DOM element.
 * @typedef {Object} HTMLElement
 */

/**
 * The built in window Event object.
 * @typedef {Object} Event
 */

 /**
 * The global jQuery object.
 * @typedef {Object} jQuery
 */
(function($, viewport, doc, WS, ob_set) {
	if (typeof ob_set === "undefined") {
		ob_set = function(ob, defaults) {
			// set default object properties
			var key;

			for (key in defaults) {
				if (defaults.hasOwnProperty(key)) {
					if (defaults[key] !== null && defaults[key].constructor === Object) {
						// traverse nested objects
						ob[key] = ob_set(ob[key] || {}, defaults[key]);
					} else if (ob[key] === undefined) {
						// replace missing objects
						ob[key] = defaults[key];
					}
				}
			}

			return ob;
		};
	}

	/**
	 * @namespace WS
	 */

	/**
	 * @typedef Options
	 * @property {Number} zindex=3000 - Base `z-index` CSS property for the main WS.WhiteBox
	 * overlay.
	 * @property {HTMLElement} root - Base root node for the overlay container. Will default to the
	 * main Document HTMLElement.
	 * @property {HTMLElement[]} - An array of HTMLElement elements which will be inserted into
	 * the WS.WhiteBox overlay Element.
	 * @memberof WS.WhiteBox
	 */

	 /**
	  * @typedef Types
	  * @property {String} 'image' - Images are directly requested from the `uri` source and the
	  * response is cached, then inserted and displayed as an `<img>` HTMLElement.
	  * @property {String} 'ajax' - an XHR is made to the `uri` source and the response is inserted
	  * and displayed as an HTMLElement.
	  * @property {String} 'inline' - An existing HTMLElement is displayed.
	  * @property {String} 'iframe' - An IFRAME HTMLElement is produced, loading the requested
	  * `uri` source, and displayed at the default `width` and `height` settings.
	  * @memberof WS.WhiteBox
	  */

	/**
	 * @callback WS.WhiteBox.OverlayLoad
	 * @arg {Object} options - Inherited from `WS.WhiteBox.Options.overlay`
	 * @arg {Object} bgoptions - Inherited from `WS.WhiteBox.Options.background`
	 * @returns {Boolean|undefined} - Return `true` to continue processing, or
	 * (`false` | `undefined`) to halt processing, and in which case, nothing will appear.
	 * @description
	 * The arguments are passed in the same order as required by [[WhiteBox#post_load_process]],
	 * which means the `arguments` variable can be sent from the callback straight to this method.
	 * This function's `this` property will be bound to the WS.Whitebox instance.
	 */

	/**
	 * @callback WS.WhiteBox.OverlayHide
	 */

	/**
	 * @event WS.WhiteBox#overlay:load
	 * @arg {Event} event
	 * @arg {Object} data
	 * @arg {WS.WhiteBox} data.handler
	 * @arg {String} data.type - The `type` argument sent to {@link WS.WhiteBox#load}.
	 * @arg {Object} data.options - The `options` argument sent to {@link WS.WhiteBox#load}.
	 * @this WS.WhiteBox#overlay
	 * @description
	 * Triggered before {@link WS.WhiteBox#load} starts loading content. If adjustments to the
	 * content within the WS.WhiteBox overlay are required on load, it is recommended to use the
	 * blocking callback {@link WS.WhiteBox.OverlayLoad}.
	 */

	/**
	 * @event WS.WhiteBox#overlay:loaded
	 * @arg {WS.WhiteBox} handler
	 * @arg {Object} data
	 * @arg {WS.WhiteBox#options} data.bgoptions
	 * @arg {WS.WhiteBox} data.handler
	 * @arg {WS.WhiteBox#options} data.options
	 * @this WS.WhiteBox#overlay
	 * @description
	 * Fires after the overlay content is loaded and (optional) callback has returned on
	 * load. This event should ideally not be used to shape or otherwise alter the geometrics
	 * of content within the overlay.
	 */

	/**
	 * Fires after the overlay is shown.
	 * @event WS.WhiteBox#overlay:shown
	 * @arg {Event} event
	 * @arg {Object} data
	 * @arg {WS.WhiteBox} data.handler
	 * @arg {WS.WhiteBox#options} data.options
	 * @this WS.WhiteBox#overlay
	 */

	/**
	 * Fires after the overlay is hidden.
	 * @event WS.WhiteBox#overlay:hidden
	 * @arg {Event} event
	 * @arg {WS.WhiteBox} handler
	 * @this WS.WhiteBox#overlay
	 */

	/**
	 * @class
	 * @version 1.0.0
	 * @arg {WS.WhiteBox.Options} options - An options object.
	 * @example
	 * // instantiate WS.WhiteBox
	 * var wswhitebox = new WS.WhiteBox();
	 */
	WS.WhiteBox = function(options) {
		var cls, my, WhiteBoxBG;

		cls = {
			/**
			 * @function WS.WhiteBox#register
			 * @arg {jQuery} elements - jQuery Object containing HTMLElements to register.
			 * @arg {String} event - 'onXX' event name to register (e.g. 'click').
			 * @arg {WS.WhiteBox.Types} type
			 * @arg {Object|Function} [options] - Either a static Object of options inherited from
			 * {@link WS.WhiteBox.defaults}.overlay, or a Function which should return the same.
			 * @arg {Boolean} [halt] - if `true`, when the Event occurs, will halt the default action
			 * and cancel propagation of the Event.
			 * @description
			 * Registers a link to be loaded within the Whitebox. This should be preferred instead
			 * of directly calling {@link WS.WhiteBox#load} for standard links.
			 *
			 * ##### Using a function for the `options` argument.
			 * The benefit of using a function for the `options` argument is that the function is
			 * fired for each element passed and is given the context of that element. The function
			 * must return a static object which will be used as the options for the related
			 * element.
			 */
			register: function() {
				return my.register.apply(cls, arguments);
			},

			/**
			 * @function WS.WhiteBox#load
			 * @arg {WS.WhiteBox.Types} type
			 * @arg {Object} [options] - Inherits from {@link WS.WhiteBox.defaults}.overlay.
			 * @arg {Object} [bgoptions] - Inherits from {@link WS.WhiteBox.defaults}.background.
			 * @description
			 * Loads a new {@link WS.WhiteBox#overlay}, replacing any currently loaded overlay.
			 */
			load: function(type, options, bgoptions) {
				if (!cls.enabled) {
					return true;
				}

				// load content before processing
				options = ob_set(options || {}, WS.WhiteBox.defaults.overlay);
				bgoptions = ob_set(bgoptions || {}, WS.WhiteBox.defaults.background);

				if (cls.active) {
					my.cleanup();
				}

				cls.overlay.trigger("overlay:load", {
					'handler': cls,
					'type': type,
					'options': options
				});

				if (options.show.modal === true) {
					cls.modal = true;
				}

				cls.overlay.className = "wb-type-" + type;

				if (options.class_name !== null) {
					cls.overlay.addClass(options.class_name);
					cls.overlay_class = options.class_name;
				}

				// get content
				switch (type) {
					case 'ajax':
						// create response container and use inline to display
						my.log("Loading " + type + " whitebox; uri: '" + options.uri + "'");

						new Ajax.Request(options.uri, {
							'method': 'post',
							'onSuccess': function(response) {
								cls.loader = $("<div>").text(response.responseText);
								cls.loader = cls.loader.childElements()[0];

								my.load_process(options, bgoptions);
							},
							'on404': function(response) {
								// redirect to 404 page
								location.href = response.request.url;
							},
							'on403': function(response) {
								// redirect to 403 page
								location.href = response.request.url;
							}
						});

						break;

					case 'inline':
						// load content from elsewhere on the page
						my.log("Loading " + type + " whitebox; uri: '" + options.element.tagName +
							(options.element.id ? "#" + options.element.id : "") + "'");

						if (options.duplicate) {
							cls.loader = options.element.clone(true, true);
						} else {
							cls.loader = options.element;
						}

						cls.loader.css({
							'display': 'block',
							'visibility': 'visible'
						});

						my.load_process(options, bgoptions);
						break;

					case 'image':
						// create image from source
						my.log("Loading " + type + " whitebox; uri: '" + options.uri + "'");

						cls.loader = new Image();

						cls.loader.onload = function() {
							doc.append(
								$(cls.loader).css({
									'display': 'block'
								})
							);

							my.load_process(options, bgoptions);
						};

						cls.loader.src = options.uri;
						break;

					default:
						// iframe content
						my.log("Loading " + type + " whitebox; uri: '" + options.uri + "'");

						if (options.uri !== undefined) {
							cls.loader = $("<iframe>", {
								'src': options.uri,
								'width': options.frame.width,
								'height': options.frame.height
							}).css({
								'display': 'block',
								'border': 0,
								'backgroundColor': '#fff'
							});
						}

						my.load_process(options, bgoptions);
				}
			},

			/**
			 * @function WS.WhiteBox#post_load_process
			 * @arg {Object} [options] - Inherits from {@link WS.WhiteBox.defaults}.overlay
			 * @arg {Object} [bgoptions] - Inherits from {@link WS.WhiteBox.defaults}.background
			 * @description
			 * Executes the third step in the WhiteBox load process. Used by the
			 * {@link WS.WhiteBox.OverlayLoad} callback function.
			 */
			post_load_process: function() {
				return my.post_load_process.apply(this, arguments);
			},

			/**
			 * Hides the WhiteBox overlay.
			 * @function WS.WhiteBox#hide
			 * @arg {Object} [options] - Inherits from {@link WS.WhiteBox.defaults}.overlay.hide.
			 */
			hide: function(options) {
				options = options || {};
				options = ob_set(options, WS.WhiteBox.defaults.overlay);

				if (!options.hide.callback ||
					(options.hide.callback && options.hide.callback.apply(cls))) {
					my.scrolling(true);
					cls.bg.hide();

					if (options.hide.delay > 0) {
						cls.overlay.animate({
							'opacity': 0
						}, (options.show.delay * 1000), options.show.easing, function() {
							cls.overlay.hide();
							cls.active = false;

							cls.overlay.trigger("overlay:hidden", cls);
							my.cleanup();
						});
					} else {
						cls.overlay.css({
							'opacity': 0
						}).hide();
						cls.active = false;

						cls.overlay.trigger("overlay:hidden", cls);
						my.cleanup();
					}
				}
			},

			/**
			 * @function WS.WhiteBox#adjust
			 * Run by {@link WS.WhiteBox#load} and on demand, this method adjusts the WhiteBox
			 * overlay to the correct centralised position on screen.
			 *
			 * If the WhiteBox overlay is larger than the viewport width it will be resized to
			 * match the viewport width.
			 */
			adjust: function() {
				var bounds, scrolled, left, top, offsets;

				bounds = my.bounds();
				scrolled = { 'left': viewport.scrollLeft(), 'top': viewport.scrollTop() };

				if (this.content.width() >= bounds.vp.width) {
					// force to screen width if too large
					this.content.css({
						'width': bounds.vp.width + 'px'
					});
				}

				// set overlay to size of content
				this.overlay.css({
					'width': this.content.width() + 'px',
					'height': this.content.height() + 'px'
				});

				// set content to show overflow
				this.content.css({
					'overflow': 'visible'
				});

				left = (Math.round((bounds.vp.width / 2) - (cls.overlay.width() / 2)) + scrolled.left);
				top = (Math.round((bounds.vp.height / 2) - (cls.overlay.height() / 2)) + scrolled.top);

				offsets = this.options.root.offset();

				left = (left - offsets.left);
				top = (top - offsets.top);

				if (left < WS.WhiteBox.defaults.overlay.frame.margin) {
					left = WS.WhiteBox.defaults.overlay.frame.margin;
				}

				if (top < WS.WhiteBox.defaults.overlay.frame.margin) {
					top = WS.WhiteBox.defaults.overlay.frame.margin;
				}

				this.overlay.css({
					'left': left + 'px',
					'top': top + 'px'
				});
			},

			/**
			 * Returns boundary dimensions of the document and viewport.
			 * @function WS.WhiteBox#bounds
			 */
			bounds: function() {
				return my.bounds.apply(this, arguments);
			}
		};

		// private methods
		my = {
			enable: function() {
				var a;

				/**
				 * Set to `true` when the WS.WhiteBox class is enabled for use.
				 * @member {Boolean} WS.WhiteBox#enabled
				 */
				cls.enabled = false;

				/**
				 * Set to `true` when WS.WhiteBox is active, and the overlay is visible
				 * @member {Boolean} WS.WhiteBox#active
				 */
				cls.active = false;

				/**
				 * Set to `true` when WS.WhiteBox is active and modal, and cannot be closed.
				 * @member {Boolean} WS.WhiteBox#modal
				 */
				cls.modal = false;

				/**
				 * Contains the currently set options for this instance. Also contains the Array of
				 * HTMLElements sent on instantiation.
				 * @member {Object} WS.WhiteBox#options
				 */
				cls.options = options || {};
				cls.options = ob_set(cls.options, {
					'zindex': 3000,
					'elements': [],
					'root': null
				});

				/**
				 * The root HTMLElement as a jQuery Object.
				 * @member {jQuery} WS.WhiteBox#root
				 */
				cls.options.root = $(cls.options.root);

				if (!cls.options.root.length) {
					cls.options.root = doc;
				}

				my.registry = [];

				/**
				 * Contains the HTMLElement currently being loaded.
				 * @member {HTMLElement} WS.WhiteBox#loader
				 */
				cls.loader = null;

				/**
				 * @member {jQuery} WS.WhiteBox#overlay
				 * @listens WS.WhiteBox#overlay:load
				 * @listens WS.WhiteBox#overlay:loaded
				 * @listens WS.WhiteBox#overlay:shown
				 * @listens WS.WhiteBox#overlay:hidden
				 * @description
				 * The overlay container for WS.WhiteBox. This contains the element `div.content`
				 * which is used for obtaining metrics of the loaded content.
				 */
				cls.options.root.append(
					cls.overlay = $("<div>", {
						'id': 'whitebox-overlay'
					}).css({
						'display': 'none',
						'opacity': '0',
						'position': 'absolute',
						'zIndex': cls.options.zindex + 1,
						'width': '100%',
						'height': '100%'
					}).append(
						cls.content = $("<div>", {
							'class': 'content'
						}).css({
							'position': 'relative',
							'overflow': 'hidden',
							'float': 'left',
							'margin': 0,
							'padding': 0
						})
					)
				);

				for (a = 0; a < cls.options.elements.length; a += 1) {
					cls.overlay.append(cls.options.elements[a]);
				}

				viewport.bind("resize", function() {
					my.resize();
				});

				cls.enabled = true;
			},

			register: function(elements, event, type, options, halt) {
				// register a link to load the whitebox on the specified event
				if (halt === undefined) {
					halt = true;
				}

				$(elements).each(function() {
					var opt, element = this;

					if (typeof options === "function") {
						opt = options.apply(element);
					} else {
						opt = options;
					}

					$(this).bind(event, function(event) {
						if (halt && cls.enabled) {
							event.preventDefault();
							event.stopPropagation();
						}

						if (cls.enabled) {
							cls.load(type, opt);
						}
					});

					my.registry.push({
						'element': this,
						'event': event,
						'type': type,
						'options': opt
					});
				});
			},

			load_process: function(options, bgoptions) {
				// step 2 of the loading process - size content container
				cls.overlay.show();

				cls.content.append(
					cls.loader
				);

				if (!options.load.callback ||
					(options.load.callback && options.load.callback.apply(cls, [options, bgoptions]))) {
					my.post_load_process(options, bgoptions);
				}
			},

			post_load_process: function(options, bgoptions) {
				// step 3 of the loading process
				var bounds;

				bounds = my.bounds();

				cls.overlay.trigger("overlay:loaded", {
					'handler': cls,
					'options': options,
					'bgoptions': bgoptions
				});

				// adjust dimensions and show
				cls.adjust();

				// finally, show the overlay
				my.show(options, bgoptions);
			},

			show: function(options, bgoptions) {
				// show the whitebox
				var a, active, bg_defaults;

				active = cls.active;
				cls.active = true;

				if (!active) {
					// was not active before
					if (options.show.modal) {
						bg_defaults = {
							'show': {
								'modal': options.show.modal
							}
						};
					} else {
						bg_defaults = {};
					}

					cls.bg.show(ob_set(bg_defaults, bgoptions));
				}

				if (options.show.scroll === false) {
					// disable scrolling (upon request)
					my.scrolling(false);
				}

				if (options.show.modal === true) {
					cls.overlay.addClass("modal");
				} else {
					cls.overlay.removeClass("modal");
				}

				if (options.show.delay > 0 && !active) {
					cls.overlay.animate({
						'opacity': 1
					}, (options.show.delay * 1000), options.show.easing, function() {
						cls.overlay.trigger("overlay:shown", {
							'handler': cls,
							'options': options
						});
					});
				} else {
					cls.overlay.css({
						'opacity': 1
					});

					if (!active) {
						cls.overlay.trigger("overlay:shown", {
							'handler': cls,
							'options': options
						});
					}
				}

				return true;
			},

			scrolling: function(scrollable) {
				// sets how the whitebox responds to scrolling
				if (scrollable) {
					// document is scrollable
					if (doc.data("overflow") !== undefined) {
						doc.css({
							'overflow': doc.data("overflow")
						});
					}
				} else {
					// remove scrolling
					if (doc.data("overflow") === undefined) {
						// data the current overflow setting for later retrieval
						doc.data(
							"overflow",
							doc.css("overflow") || "auto"
						);
					}

					doc.css({
						'overflow': 'hidden'
					});
				}
			},

			cleanup: function() {
				// cleans up variables and elements on removal
				var a;

				if (cls.loader) {
					if (cls.loader.parentNode) {
						cls.loader.remove();
					}

					cls.loader = null;
				}

				cls.content.css({
					'overflow': 'hidden',
					'width': 'auto',
					'height': 'auto'
				}).text("");

				cls.overlay.css({
					'width': '100%',
					'height': '100%'
				}).hide().css({
					'opacity': 0
				});

				if (cls.overlay_class !== null) {
					cls.overlay.removeClass(cls.overlay_class);
					delete cls.overlay_class;
				}

				for (a = 0; a < cls.options.elements.length; a += 1) {
					cls.options.elements[a].removeClass("disabled");
				}
			},

			resize: function() {
				// executed when the window is resized
				var left, bounds, scrolled_left, offsets;

				bounds = my.bounds();
				scrolled_left = viewport.scrollLeft();
				left = (Math.round((bounds.vp.width / 2) - (cls.overlay.width() / 2)) + scrolled_left);
				offsets = cls.options.root.offset();

				left = (left - offsets[0]);

				cls.overlay.css({
					'left': left + 'px'
				});
			},

			bounds: function() {
				// data the maximum x and y boundaries of the active document
				var vp_dimensions, doc_dimensions, w, h;

				vp_dimensions = { 'width': viewport.width(), 'height': viewport.height() };
				doc_dimensions = { 'width': doc.width(), 'height': doc.height() };

				w = (doc_dimensions.width > vp_dimensions.width ? doc_dimensions.width : vp_dimensions.width);
				h = (doc_dimensions.height > vp_dimensions.height ? doc_dimensions.height : vp_dimensions.height);

				return { 'width': w, 'height': h, 'vp': { 'width': vp_dimensions.width, 'height': vp_dimensions.height } };
			},

			log: function(msg) {
				// log event to the console (if active)
				if (typeof console !== "undefined") {
					console.log(msg);
				}
			}
		};

		/**
		 * Fires after the background layer is shown.
		 * @event WS.WhiteBoxBG#shader:shown
		 * @arg {Event} event
		 * @arg {WS.WhiteBoxBG#shader} shader
		 * @this WS.WhiteBoxBG#shader
		 */

		/**
		 * Fires after the background layer is hidden.
		 * @event WS.WhiteBoxBG#shader:hidden
		 * @arg {Event} event
		 * @arg {WS.WhiteBoxBG#shader} shader
		 * @this WS.WhiteBoxBG#shader
		 */

		/**
		 * @class WS.WhiteBoxBG
		 * @description
		 * This class is internal to whitebox and cannot be used or instanced directly. Instead,
		 * the {@link WS.WhiteBox#bg} member - which is an instance of the class - should be used.
		 * This class is mentioned here purely for documentation purposes.
		 */
		WhiteBoxBG = function($super) {
			var my, bounds, offset;

			bounds = $super.bounds();
			offset = $super.options.root.offset();

			my = {
				shader: $("<div>", {
					'id': 'whitebox-bg'
				}).css({
					'position': 'fixed',
					'zIndex': $super.options.zindex,
					'left': 0,
					'top': 0,
					'right': 0,
					'bottom': 0
				}).hide()
			};

			$super.options.root.append(
				my.shader
			);

			my.shader.css({
				'opacity': 0
			});

			return {
				/**
				 * The shader background HTMLElement, stored as a jQuery Object.
				 * @member {jQuery} WS.WhiteBoxBG#shader
				 * @listens WS.WhiteBoxBG#shader:shown
				 * @listens WS.WhiteBoxBG#shader:hidden
				 */
				shader: my.shader,

				/**
				 * Shows the background layer
				 * @function WS.WhiteBoxBG#show
				 * @arg {Object} options - Options inherit from
				 * {@link WS.WhiteBox.defaults}.background
				 */
				show: function(options) {
					options = ob_set(options || {}, WS.WhiteBox.defaults.background);

					$super.adjust(true, true);
					my.shader.show();

					if (!options.show.modal) {
						my.shader.bind("click", function() {
							$super.hide();
						});

						my.shader.removeClass("modal");
					} else {
						my.shader.addClass("modal");
					}

					if (options.show.delay > 0) {
						// show with animation
						my.shader.animate({
							'opacity': options.opacity
						}, (options.show.delay * 1000), options.show.easing, function() {
							my.shader.trigger("shader:shown", this);
						});
					} else {
						// show without animation
						my.shader.css({
							'opacity': options.opacity
						});
						my.shader.trigger("shader:shown", this);
					}
				},

				/**
				 * Hides the background layer
				 * @function WS.WhiteBoxBG#hide
				 * @arg {Object} options - Options inherit from
				 * {@link WS.WhiteBox.defaults}.background
				 */
				hide: function(options) {
					options = options || {};
					options = ob_set(options, WS.WhiteBox.defaults.background);

					my.shader.unbind("click");

					if (options.hide.delay > 0) {
						// hide with animation
						my.shader.animate({
							'opacity': 0
						}, (options.hide.delay * 1000), options.hide.easing, function() {
							my.shader.hide();
							my.shader.trigger("shader:hidden", this);
						});
					} else {
						// hide without animation
						my.shader.css({
							'opacity': 0
						});
						my.shader.hide();
						my.shader.trigger("shader:hidden", this);
					}
				},

				adjust: function(bounds, offset) {
					if (!bounds) {
						bounds = my.bounds();
					}

					offset = offset || [0, 0];
				}
			};
		};

		// enable class
		my.enable();

		/**
		* An instance of the {@link WS.WhiteBoxBG} class. This instance should be used to run
		* the methods provided by WS.WhiteBoxBg.
		* @member WS.WhiteBox#bg
		**/
		cls.bg = new WhiteBoxBG(cls);

		return cls;
	};

	/**
	 * @static
	 * @property {Object} overlay - Overlay options - passed to {@link WS.WhiteBox#load}.
	 * @property {String} overlay.class_name - Extra class name to apply to the overlay.
	 * @property {Object} overlay.frame - IFRAME overlay options. The `width` and `height` of an
	 * IFRAME's content cannot be computed so they must be supplied. (_Don't worry, there are
	 * defaults_).
	 * @property {Number} overlay.frame.width=800 - IFRAME width.
	 * @property {Number} overlay.frame.height=450 - IFRAME height.
	 * @property {String} overlay.uri - Source URI for loading `ajax`, `iframe` or `image` content.
	 * @property {HTMLElement} overlay.element - Source element for loading `inline` content.
	 * @property {Boolean} overlay.duplicate=true When set to `true`, inline elements will be
	 * duplicated.
	 * When set to `false`, the original source element will be sent to the Whitebox overlay.
	 * **Warning:** Inline elements sent as originals to Whitebox will be **destroyed** when
	 * WS.Whitebox closes.
	 * @property {Object} load - Load options.
	 * @property {WS.WhiteBox.OverlayLoad} load.callback - Run before the loaded content is
	 * displayed.
	 * @property {Object} show - Show options.
	 * @property {Number} show.delay=0.3 - Appear animation length (in seconds). (Set to `0` for
	 * instant display.)
	 * @property {Boolean} show.modal=false - When `true` will not close by clicking either the close
	 * button or the background layer.
	 * @property {Boolean} show.scroll - Controls whether or not the document can be scrolled while
	 * WS.WhiteBox is actively showing content.
	 * @property {Object} hide - Hide options.
	 * @property {WS.WhiteBox.OverlayHide} hide.callback - Run when the loaded content closes.
	 * @property {Number} hide.delay=0 - Animation length for fading of the WS.WhiteBox interface.
	 * @property {Object} background - Background layer options.
	 * @property {Number} background.opacity=0.5 - Background opacity (from 0 to 1). This is
	 * a setting independent of CSS colouring.
	 * @property {Object} background.show - Show options.
	 * @property {Number} background.show.delay=0.3 - Animation speed (in seconds) on background
	 * show.
	 * @property {Boolean} background.show.modal=false - When `true`, the background layer cannot
	 * be clicked to close any active WS.WhiteBox displays. When `overlay.show.modal` is `true`,
	 * this settings is overridden.
	 * @property {Object} background.hide - Hide options.
	 * @property {Number} background.hide.delay=0.3 - Animation speed (in seconds) on background hide.
	 * @description
	 * This is an object created for the purposes of providing default options to WS.Whitebox on
	 * creation. These defaults can be adjusted on instantiation of the {@link WS.WhiteBox} class.
	 */
	WS.WhiteBox.defaults = {
		'overlay': {
			'class_name': null,
			'frame': {
				'width': 800,
				'height': 450,
				'margin': 15
			},
			'uri': null,
			'element': null,
			'duplicate': true,
			'load': {
				'callback': null
			},
			'show': {
				'delay': 0.3,
				'modal': false,
				'easing': 'swing',
				'scroll': true
			},
			'hide': {
				'callback': null,
				'delay': 0
			}
		},
		'background': {
			'opacity': 0.5,
			'show': {
				'delay': 0.3,
				'modal': false,
				'easing': 'swing'
			},
			'hide': {
				'delay': 0.3,
				'easing': 'swing'
			}
		}
	};

	window.WS = WS;
}(window.jQuery, window.jQuery(window), window.jQuery(document.body), (window.WS || {}), window.ob_set));
